import clsx from "clsx";

import { Checkbox } from "@/design-system/components/Checkbox/Checkbox";
import { AutoDetectedTag } from "@/InsightsPage/components/AutoDetectedTag";
import { FunnelEvents } from "@/api/insights";

interface EventListItemProps {
  event: FunnelEvents;
  isSelected: boolean;
  isDisabled: boolean;
  isFocused: boolean;
  onMouseOver: () => void;
  onToggle: () => void;
}

export function EventListItem({
  event,
  isSelected,
  isDisabled,
  isFocused,
  onMouseOver,
  onToggle,
}: EventListItemProps) {
  return (
    <button
      type="button"
      data-event-id={event.eventDefId}
      onMouseOver={onMouseOver}
      onClick={() => !isDisabled && onToggle()}
      className={clsx(
        "flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left select-none",
        isDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer",
        isFocused ? "bg-surface-hover" : "hover:bg-surface-hover/60",
      )}
    >
      <span className="shrink-0">
        <Checkbox
          checked={isSelected}
          disabled={isDisabled}
          onCheckedChange={() => !isDisabled && onToggle()}
        />
      </span>
      <div className="flex min-w-0 flex-col">
        <span className="flex items-center gap-1.5 text-sm break-words">
          {event.name}
          <AutoDetectedTag conversionSource={event.conversionSource} />
        </span>
        <span className="text-textSubtle text-xs">
          {event.adPlatformsDelivered ?? 0} supported integrations
        </span>
      </div>
    </button>
  );
}
